import { render, staticRenderFns } from "./ExchangeItemDetails.vue?vue&type=template&id=78944498&scoped=true"
import script from "./ExchangeItemDetails.vue?vue&type=script&lang=js"
export * from "./ExchangeItemDetails.vue?vue&type=script&lang=js"
import style0 from "./ExchangeItemDetails.vue?vue&type=style&index=0&id=78944498&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78944498",
  null
  
)

export default component.exports